import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}

export type Prettify<T> = { [K in keyof T]: T[K] } & {};

export type ToDiscriminatedUnion<
	T extends Record<string, object>,
	DiscriminantKey extends string = "type",
> = {
	[K in keyof T]: Prettify<
		{
			[P in DiscriminantKey]: K;
		} & T[K]
	>;
}[keyof T];
